import { defaultEventCategorySet, EventCategorySet, TaskLabel } from '@demind-inc/core';
import { kebabCase, uniqBy } from 'lodash';

const normalizeEventCategoryId = (categoryId: string): string => {
  const withoutDefault = categoryId.replace(/^default_?/i, '');
  return kebabCase(withoutDefault);
};

export const resolveEventCategoryFromCategoryId = (
  categoryRaw?: string | null
): EventCategorySet | undefined => {
  if (!categoryRaw?.trim()) {
    return undefined;
  }

  const trimmed = categoryRaw.trim();

  return defaultEventCategorySet.find(
    ({ id, name }) =>
      id === trimmed ||
      normalizeEventCategoryId(id) === kebabCase(trimmed) ||
      normalizeEventCategoryId(id) === normalizeEventCategoryId(trimmed) ||
      name.toLowerCase() === trimmed.toLowerCase()
  );
};

const matchTaskLabelToEventCategory = (label: TaskLabel): EventCategorySet | undefined => {
  if (label.name) {
    const matchedByName = defaultEventCategorySet.find(
      ({ name }) => name.toLowerCase() === label.name.toLowerCase()
    );
    if (matchedByName) {
      return matchedByName;
    }
  }

  if (!label.id) {
    return undefined;
  }

  return defaultEventCategorySet.find(
    ({ id }) => label.id === id || label.id.endsWith(`_${id}`) || label.id.endsWith(id)
  );
};

export const transformTaskLabelsToEventCategories = (
  labels?: TaskLabel[]
): EventCategorySet[] | undefined => {
  if (!labels?.length) {
    return undefined;
  }

  const categories = uniqBy(
    labels
      .map((label) => matchTaskLabelToEventCategory(label))
      .filter((category): category is EventCategorySet => !!category),
    'id'
  );

  return categories.length ? categories : undefined;
};
